// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"d6c4ce02f2c0c72b","4291":"a94edea58437ccb0"}[chunkId] + ".css";
};